const permissions = {
    check: () => {
    },
    PERMISSIONS: () => {
    },
    RESULTS: () => {
    }
}

export default permissions;
